// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"1e65ef35","301":"d85f448a"}[chunkId] + ".chunk.css";
};